import axios from 'axios';

function isEmpty(val){
	let type = getObjectType(val);
	//console.log(type);
	switch(type){
		case 'Object':
			return Object.keys(val).length === 0;
		case 'Array':
			return val.length === 0;
		case 'String':
			return val === "" || val === 'null' || val === 'undefined';
		case 'Number':
			return val === 0;
    case 'Date':
      return false;
		default:
			return true;
	}
}

function getObjectType(val){
	let type = Object.prototype.toString.call(val);
	switch(type){
		case '[object Object]':
			return 'Object';
		case '[object Array]':
			return 'Array';
		case '[object String]':
			return 'String';
		case '[object Number]':
			return 'Number';
		case '[object Null]':
			return 'Null';
    case '[object Date]':
      return 'Date';
		default:
			return 'Undefined';
	}
}

function getMonthTime(month,type,year){
	month = month.toString();
	if(isEmpty(year)) year = new Date().getFullYear();
	let monthTime = {};
	let monthDays = getMonthDays(month,year);
	let starttime = year + "-" + month + "-01 00:00:01";
	let endtime = year + "-" + month + "-" + monthDays.toString() + " 23:59:59";
	if(type === 'unx' || 'UNX') {
		monthTime.starttime = new Date(starttime).getTime() / 1000;
		monthTime.endtime = new Date(endtime).getTime() / 1000;
	} else {
		monthTime.starttime = starttime;
		monthTime.endtime = endtime;
	}
	return monthTime;
}

function getMonthDays(month,year){
	month = Number(month);
	if(year === undefined || year === "") year = new Date().getFullYear();
	if(month > 0 && month <= 12){
		if(month === 4 || month === 6 || month === 9 || month === 11) return 30;
		else if(month === 2){
			if ((year % 4 === 0 && !(year % 100 === 0)) || year % 400 === 0) return 29
			else return 28
		} else return 31
	}
}

async function request(url,params,isUpload = false){
	if(!isEmpty(url)){
		try{
			const token = localStorage.getItem('token');
			const headers = {'WX-TOKEN': token}
			if(isUpload) headers['Content-Type'] = 'multipart/form-data';
			const apiInstance = axios.create({
			  headers
			});
			const res = await apiInstance.post(url,params);
      //console.log(res);
			return res.data;
		}catch(e){
      //console.log(e)
			const result = e.response.data;
			if(result.code == '-1001'){
      	localStorage.setItem('token', '');
      	window.$appRouter.push('/login');
			}
			return result['errMsg'];
		}
	} else {
		return "请求链接为空";
	}
}

function formatObjectToString(obj){
	let s = "";
	if(isEmpty(obj))
		return '';
	else {
		for(let key in obj)
			s += (key + "=" + obj[key] + "&");
		return s.slice(0,-1);
	}
}

function sliceList(arr, size) { //数组拆分

  let arr2=[];
  for(let i = 0; i < arr.length; i += size){
    arr2.push(arr.slice(i,i+size));
  }
  return arr2;
}

function formatDate(d){
	if(!d)
		return "";
	let time = new Date(d);
	let year = time.getFullYear() + '';
	let month = time.getMonth() + 1 + '';
	let date = time.getDate() + '';
	return (year + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date));
}

function formatDateToMonth(d){
  if(d === "" || d === 0)
    return "";
  let time = new Date(d);
  let year = time.getFullYear() + '';
  let month = time.getMonth() + 1 + '';
  return (year + '-' + (month < 10 ? '0' + month : month));
}

function getFamtterTimer(time){
	let date = new Date(time);
	let Y = date.getFullYear();
	let M = date.getMonth() + 1;
	let D = date.getDate();
	let h = date.getHours();
	let m = date.getMinutes();
	let s = date.getSeconds();
	return Y + '-' + getZero(M) + '-' + getZero(D) + ' ' + getZero(h) + ':' + getZero(m) + ':' + getZero(s);
}

function getZero(num){
	if(parseInt(num) < 10){
		num = '0' + num;
	}
	return num;
}

function formatExcelDate(number,format){
  if(isEmpty(number)){
    return '';
  }
  let time = new Date(number);
  if(!Number.isNaN(Number(number))){
    time = new Date(1900, 0, 1);
    time.setDate(time.getDate() + number - 2);
  }
  let year = time.getFullYear() ;
  let month = time.getMonth() + 1 ;
  let date = time.getDate();

  return (year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date)) + "";
}

function isChinese(str) {
  return /^[\u4E00-\u9FA5\uF900-\uFA2D]+$/.test(str);
}

function isEnd(str){
	return /^[,，；;、+\s]+$/.test(str);
}

function smartMatch(remark,query) {
  const regex = new RegExp(query.split('').join('.*'), 'i');
  //return options.filter(option => regex.test(option));
  return regex.test(remark);
}

function formatOptions(searchList){ //获取当前所输入的所有条件
  let options = {};

  for(let searchItem in searchList){

    if(!isEmpty(searchList[searchItem]) && searchItem !== 'audit'){
      console.log("have list")
      if(searchItem.includes('Date')) {
        let templist = [];
        if(Object.prototype.toString.call(searchList[searchItem]) === '[object Array]'){
          let month = new Date(searchList[searchItem][1]).getMonth() + 1;
          let day = getMonthDays(month,new Date().getFullYear())
          templist.push(formatDateToMonth(searchList[searchItem][0]) + "-01 00:00:01");
          templist.push(formatDateToMonth(searchList[searchItem][1]) + "-" + day + " 23:59:59");
        }else{
          let tempDate = new Date(searchList[searchItem]);
          let y = tempDate.getFullYear();
          let m = tempDate.getMonth() + 1;
          templist.push(y + "-" + m + "-01 00:00:01");
          let d = getMonthDays(m,y);
          templist.push(y + "-" + m + "-" + d + " 23:59:59");
        }
        options[searchItem] = templist;
      }else{
        options[searchItem] = searchList[searchItem];
      }
    }
  }
  return options;
}

export default {
	getMonthDays,
	getMonthTime,
	getObjectType,
	isEmpty,
	request,
	formatObjectToString,
	sliceList,
	formatDate,
	getFamtterTimer,
  formatDateToMonth,
  formatExcelDate,
  isChinese,
  isEnd,
  formatOptions,
  smartMatch
}



//////////////////
// WEBPACK FOOTER
// ./static/util.js
// module id = null
// module chunks = 